/**
 * 侧边栏 — 菜单项与 `prisma/seed.ts` 中 `admin_menus.route` 一致，文案为简体中文。
 */
import { Menu, Layout } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { useTabsStore } from '../store/tabs';
import { canAccessAdminMenuLeaf, groupMenuLeaves } from '../config/admin-menu-tree';

const { Sider } = Layout;

export function Sidebar() {
  const hasMenu = useAuthStore((s) => s.hasMenu);
  const hasNode = useAuthStore((s) => s.hasNode);
  const openTab = useTabsStore((s) => s.open);
  const navigate = useNavigate();
  const activeKey = useTabsStore((s) => s.activeKey);
  /** e.g. `platform.user.detail:12` → highlight「会员详情」菜单 */
  const menuSelectedKey =
    activeKey && activeKey.includes(':') ? (activeKey.split(':')[0] as string) : activeKey;

  const visible = groupMenuLeaves()
    .map((group) => ({
      ...group,
      children: group.children.filter((c) => canAccessAdminMenuLeaf(c, hasMenu, hasNode)),
    }))
    .filter((g) => g.children.length > 0);

  const items = visible.map((g) => ({
    key: g.key,
    icon: g.icon,
    label: g.label,
    children: g.children.map((c) => ({
      key: c.route,
      icon: c.icon,
      label: c.labelZh,
    })),
  }));

  return (
    <Sider width={220} theme="dark" style={{ overflow: 'auto' }}>
      <div
        style={{
          height: 56,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          padding: '0 12px',
          color: '#fff',
          fontWeight: 600,
          fontSize: 14,
          letterSpacing: 0.5,
        }}
      >
        <img src="/orb.jpeg" alt="" width={32} height={32} style={{ borderRadius: 6, objectFit: 'cover' }} />
        <span style={{ whiteSpace: 'nowrap' }}>ORB · 运营后台</span>
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultOpenKeys={
          visible.length
            ? visible.slice(0, 3).map((g) => String(g.key))
            : ['system', 'platform', 'ep']
        }
        selectedKeys={menuSelectedKey ? [menuSelectedKey] : []}
        items={items}
        onClick={({ key }) => {
          for (const g of visible) {
            const leaf = g.children.find((c) => c.route === key);
            if (leaf) {
              openTab({
                key: leaf.route,
                label: leaf.labelZh,
                path: leaf.path,
                closable: leaf.route !== 'platform.dashboard',
              });
              navigate(leaf.path);
              return;
            }
          }
        }}
      />
    </Sider>
  );
}
